import React from "react";
import { useNavigate } from "react-router-dom";
import { LockIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useGetHomeQuery } from "@/store/rest_api";
import { MembershipRole } from "@/enum/MembershipRole";
import { MembershipStatus } from "@/enum/MembershipStatus";

interface AddOnUpsellProps {
  title: string;
  description: string;
  price?: string;
}

export function AddOnUpsell({ title, description, price }: AddOnUpsellProps) {
  const navigate = useNavigate();
  const { data: user } = useGetHomeQuery();
  const membership = user?.activeMembership;
  const canManage =
    membership?.status === MembershipStatus.ACTIVE &&
    (membership.role === MembershipRole.OWNER || membership.role === MembershipRole.ADMIN);

  return (
    <div className="flex flex-col items-center justify-center h-full p-8 text-center">
      <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 mb-4">
        <LockIcon className="h-7 w-7 text-primary" />
      </div>
      <h1 className="text-2xl font-bold mb-1">{title}</h1>
      <p className="text-muted-foreground max-w-md mb-2">{description}</p>
      {price && <p className="text-sm font-medium mb-4">{price}</p>}
      {canManage ? (
        <Button onClick={() => navigate("/manage-organisation/billing/add-ons")}>Add this add-on</Button>
      ) : (
        <p className="text-sm text-muted-foreground">Ask an organisation owner or admin to enable this add-on.</p>
      )}
    </div>
  );
}
